import type { IExpensePersonal } from './ExpensePersonal.interface';
import { PaymentFrequency } from '../global/PaymentFrequency.enum';

export default class ExpensePersonal implements IExpensePersonal {
  foodAndSupermarketItems: number;
  foodAndSupermarketItemsFrequency: PaymentFrequency;
  foodAndSupermarketItemsComments: string;
  clothingShoesAccessories: number;
  clothingShoesAccessoriesFrequency: PaymentFrequency;
  clothingShoesAccessoriesComments: string;
  phoneInternetPayTV: number;
  phoneInternetPayTVFrequency: PaymentFrequency;
  phoneInternetPayTVComments: string;
  hairdressingGrooming: number;
  hairdressingGroomingFrequency: PaymentFrequency;
  hairdressingGroomingComments: string;
  coffeeLunchesTakeaway: number;
  coffeeLunchesTakeawayFrequency: PaymentFrequency;
  coffeeLunchesTakeawayComments: string;
  entertainment: number;
  entertainmentFrequency: PaymentFrequency;
  entertainmentComments: string;
  cigarettesAndAlcohol: number;
  cigarettesAndAlcoholFrequency: PaymentFrequency;
  cigarettesAndAlcoholComments: string;
  giftsAndCelebrations: number;
  giftsAndCelebrationsFrequency: PaymentFrequency;
  giftsAndCelebrationsComments: string;
  holidays: number;
  holidaysFrequency: PaymentFrequency;
  holidaysComments: string;
  schoolFeesUniformsEducation: number;
  schoolFeesUniformsEducationFrequency: PaymentFrequency;
  schoolFeesUniformsEducationComments: string;
  childCare: number;
  childCareFrequency: PaymentFrequency;
  childCareComments: string;
  childMaintenance: number;
  childMaintenanceFrequency: PaymentFrequency;
  childMaintenanceComments: string;
  gymFeesSport: number;
  gymFeesSportFrequency: PaymentFrequency;
  gymFeesSportComments: string;
  privateHealthInsurance: number;
  privateHealthInsuranceFrequency: PaymentFrequency;
  privateHealthInsuranceComments: string;
  doctorDentistPharmacy: number;
  doctorDentistPharmacyFrequency: PaymentFrequency;
  doctorDentistPharmacyComments: string;
  glassesAndEyeCare: number;
  glassesAndEyeCareFrequency: PaymentFrequency;
  glassesAndEyeCareComments: string;
  petsFoodCareVet: number;
  petsFoodCareVetFrequency: PaymentFrequency;
  petsFoodCareVetComments: string;
  lifeTraumaIncomeInsurances: number;
  lifeTraumaIncomeInsurancesFrequency: PaymentFrequency;
  lifeTraumaIncomeInsurancesComments: string;
  anyOtherInsurances: number;
  anyOtherInsurancesFrequency: PaymentFrequency;
  anyOtherInsurancesComments: string;
  other: number;
  otherFrequency: PaymentFrequency;
  otherComments: string;

  static build = (data: IExpensePersonal) => new ExpensePersonal(data);
  static blank = () => new ExpensePersonal();

  /**
   * Constructor
   * @param {IExpensePersonal} data
   */
  constructor(data?: IExpensePersonal) {
    this.foodAndSupermarketItems = parseFloat(data?.foodAndSupermarketItems || 0);
    // TODO: data?.foodAndSupermarketItemsFrequency is legacy data structure
    this.foodAndSupermarketItemsFrequency = data?.foodAndSupermarketItemsFrequency
      ? PaymentFrequency.of(
          data?.foodAndSupermarketItemsFrequency?.name ||
            data?.foodAndSupermarketItemsFrequency.toString()
        )
      : PaymentFrequency.weekly;
    this.foodAndSupermarketItemsComments = data?.foodAndSupermarketItemsComments || '';
    this.clothingShoesAccessories = parseFloat(data?.clothingShoesAccessories || 0);
    // TODO: data?.clothingShoesAccessoriesFrequency is legacy data structure
    this.clothingShoesAccessoriesFrequency = data?.clothingShoesAccessoriesFrequency
      ? PaymentFrequency.of(
          data?.clothingShoesAccessoriesFrequency?.name ||
            data?.clothingShoesAccessoriesFrequency.toString()
        )
      : PaymentFrequency.annually;
    this.clothingShoesAccessoriesComments = data?.clothingShoesAccessoriesComments || '';
    this.phoneInternetPayTV = parseFloat(data?.phoneInternetPayTV || 0);
    // TODO: data?.phoneInternetPayTVFrequency is legacy data structure
    this.phoneInternetPayTVFrequency = data?.phoneInternetPayTVFrequency
      ? PaymentFrequency.of(
          data?.phoneInternetPayTVFrequency?.name ||
            data?.phoneInternetPayTVFrequency.toString()
        )
      : PaymentFrequency.monthly;
    this.phoneInternetPayTVComments = data?.phoneInternetPayTVComments || '';
    this.hairdressingGrooming = parseFloat(data?.hairdressingGrooming || 0);
    // TODO: data?.hairdressingGroomingFrequency is legacy data structure
    this.hairdressingGroomingFrequency = data?.hairdressingGroomingFrequency
      ? PaymentFrequency.of(
          data?.hairdressingGroomingFrequency?.name ||
            data?.hairdressingGroomingFrequency.toString()
        )
      : PaymentFrequency.monthly;
    this.hairdressingGroomingComments = data?.hairdressingGroomingComments || '';
    this.coffeeLunchesTakeaway = parseFloat(data?.coffeeLunchesTakeaway || 0);
    // TODO: data?.coffeeLunchesTakeawayFrequency is legacy data structure
    this.coffeeLunchesTakeawayFrequency = data?.coffeeLunchesTakeawayFrequency
      ? PaymentFrequency.of(
          data?.coffeeLunchesTakeawayFrequency?.name ||
            data?.coffeeLunchesTakeawayFrequency.toString()
        )
      : PaymentFrequency.weekly;
    this.coffeeLunchesTakeawayComments = data?.coffeeLunchesTakeawayComments || '';
    this.entertainment = parseFloat(data?.entertainment || 0);
    // TODO: data?.entertainmentFrequency is legacy data structure
    this.entertainmentFrequency = data?.entertainmentFrequency
      ? PaymentFrequency.of(
          data?.entertainmentFrequency?.name || data?.entertainmentFrequency.toString()
        )
      : PaymentFrequency.monthly;
    this.entertainmentComments = data?.entertainmentComments || '';
    this.cigarettesAndAlcohol = parseFloat(data?.cigarettesAndAlcohol || 0);
    // TODO: data?.cigarettesAndAlcoholFrequency is legacy data structure
    this.cigarettesAndAlcoholFrequency = data?.cigarettesAndAlcoholFrequency
      ? PaymentFrequency.of(
          data?.cigarettesAndAlcoholFrequency?.name ||
            data?.cigarettesAndAlcoholFrequency.toString()
        )
      : PaymentFrequency.weekly;
    this.cigarettesAndAlcoholComments = data?.cigarettesAndAlcoholComments || '';
    this.giftsAndCelebrations = parseFloat(data?.giftsAndCelebrations || 0);
    // TODO: data?.giftsAndCelebrationsFrequency is legacy data structure
    this.giftsAndCelebrationsFrequency = data?.giftsAndCelebrationsFrequency
      ? PaymentFrequency.of(
          data?.giftsAndCelebrationsFrequency?.name ||
            data?.giftsAndCelebrationsFrequency.toString()
        )
      : PaymentFrequency.annually;
    this.giftsAndCelebrationsComments = data?.giftsAndCelebrationsComments || '';
    this.holidays = parseFloat(data?.holidays || 0);
    // TODO: data?.holidaysFrequency is legacy data structure
    this.holidaysFrequency = data?.holidaysFrequency
      ? PaymentFrequency.of(data?.holidaysFrequency?.name || data?.holidaysFrequency.toString())
      : PaymentFrequency.annually;
    this.holidaysComments = data?.holidaysComments || '';
    this.schoolFeesUniformsEducation = parseFloat(data?.schoolFeesUniformsEducation || 0);
    // TODO: data?.schoolFeesUniformsEducationFrequency is legacy data structure
    this.schoolFeesUniformsEducationFrequency = data?.schoolFeesUniformsEducationFrequency
      ? PaymentFrequency.of(
          data?.schoolFeesUniformsEducationFrequency?.name ||
            data?.schoolFeesUniformsEducationFrequency.toString()
        )
      : PaymentFrequency.monthly;
    this.schoolFeesUniformsEducationComments = data?.schoolFeesUniformsEducationComments || '';
    this.childCare = parseFloat(data?.childCare || 0);
    // TODO: data?.childCareFrequency is legacy data structure
    this.childCareFrequency = data?.childCareFrequency
      ? PaymentFrequency.of(
          data?.childCareFrequency?.name || data?.childCareFrequency.toString()
        )
      : PaymentFrequency.monthly;
    this.childCareComments = data?.childCareComments || '';
    this.childMaintenance = parseFloat(data?.childMaintenance || 0);
    // TODO: data?.childMaintenanceFrequency is legacy data structure
    this.childMaintenanceFrequency = data?.childMaintenanceFrequency
      ? PaymentFrequency.of(
          data?.childMaintenanceFrequency?.name || data?.childMaintenanceFrequency.toString()
        )
      : PaymentFrequency.monthly;
    this.childMaintenanceComments = data?.childMaintenanceComments || '';
    this.gymFeesSport = parseFloat(data?.gymFeesSport || 0);
    // TODO: data?.gymFeesSportFrequency is legacy data structure
    this.gymFeesSportFrequency = data?.gymFeesSportFrequency
      ? PaymentFrequency.of(
          data?.gymFeesSportFrequency?.name || data?.gymFeesSportFrequency.toString()
        )
      : PaymentFrequency.monthly;
    this.gymFeesSportComments = data?.gymFeesSportComments || '';
    this.privateHealthInsurance = parseFloat(data?.privateHealthInsurance || 0);
    // TODO: data?.privateHealthInsuranceFrequency is legacy data structure
    this.privateHealthInsuranceFrequency = data?.privateHealthInsuranceFrequency
      ? PaymentFrequency.of(
          data?.privateHealthInsuranceFrequency?.name ||
            data?.privateHealthInsuranceFrequency.toString()
        )
      : PaymentFrequency.monthly;
    this.privateHealthInsuranceComments = data?.privateHealthInsuranceComments || '';
    this.doctorDentistPharmacy = parseFloat(data?.doctorDentistPharmacy || 0);
    // TODO: data?.doctorDentistPharmacyFrequency is legacy data structure
    this.doctorDentistPharmacyFrequency = data?.doctorDentistPharmacyFrequency
      ? PaymentFrequency.of(
          data?.doctorDentistPharmacyFrequency?.name ||
            data?.doctorDentistPharmacyFrequency.toString()
        )
      : PaymentFrequency.annually;
    this.doctorDentistPharmacyComments = data?.doctorDentistPharmacyComments || '';
    this.glassesAndEyeCare = parseFloat(data?.glassesAndEyeCare || 0);
    // TODO: data?.glassesAndEyeCareFrequency is legacy data structure
    this.glassesAndEyeCareFrequency = data?.glassesAndEyeCareFrequency
      ? PaymentFrequency.of(
          data?.glassesAndEyeCareFrequency?.name || data?.glassesAndEyeCareFrequency.toString()
        )
      : PaymentFrequency.annually;
    this.glassesAndEyeCareComments = data?.glassesAndEyeCareComments || '';
    this.petsFoodCareVet = parseFloat(data?.petsFoodCareVet || 0);
    // TODO: data?.petsFoodCareVetFrequency is legacy data structure
    this.petsFoodCareVetFrequency = data?.petsFoodCareVetFrequency
      ? PaymentFrequency.of(
          data?.petsFoodCareVetFrequency?.name || data?.petsFoodCareVetFrequency.toString()
        )
      : PaymentFrequency.monthly;
    this.petsFoodCareVetComments = data?.petsFoodCareVetComments || '';
    this.lifeTraumaIncomeInsurances = parseFloat(data?.lifeTraumaIncomeInsurances || 0);
    // TODO: data?.lifeTraumaIncomeInsurancesFrequency is legacy data structure
    this.lifeTraumaIncomeInsurancesFrequency = data?.lifeTraumaIncomeInsurancesFrequency
      ? PaymentFrequency.of(
          data?.lifeTraumaIncomeInsurancesFrequency?.name ||
            data?.lifeTraumaIncomeInsurancesFrequency.toString()
        )
      : PaymentFrequency.annually;
    this.lifeTraumaIncomeInsurancesComments = data?.lifeTraumaIncomeInsurancesComments || '';
    this.anyOtherInsurances = parseFloat(data?.anyOtherInsurances || 0);
    // TODO: data?.anyOtherInsurancesFrequency is legacy data structure
    this.anyOtherInsurancesFrequency = data?.anyOtherInsurancesFrequency
      ? PaymentFrequency.of(
          data?.anyOtherInsurancesFrequency?.name ||
            data?.anyOtherInsurancesFrequency.toString()
        )
      : PaymentFrequency.annually;
    this.anyOtherInsurancesComments = data?.anyOtherInsurancesComments || '';
    this.other = parseFloat(data?.other || 0);
    // TODO: data?.otherFrequency is legacy data structure
    this.otherFrequency = data?.otherFrequency
      ? PaymentFrequency.of(data?.otherFrequency?.name || data?.otherFrequency.toString())
      : PaymentFrequency.monthly;
    this.otherComments = data?.otherComments || '';
  }
}
